import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex: 1 0 auto;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
`;
